import script from "./PersonCalendarScheduling.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonCalendarScheduling.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__